import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import Paragraph from '../Paragraph/Paragraph';
import { variables } from '../../assets/styles/variables';
import { ReactComponent as ArrowRight } from '../../assets/images/svg/chevron-right.svg';

const RowItem = styled.div`
  border-top: 1px solid ${themeColors.colorBorderPrimary};
  height: ${pxToRem(52)};
  display: flex;
  align-items: center;
  padding: 0 ${pxToRem(16)};
  margin: 0 -${pxToRem(16)};
  width: calc(100% + pxToRem(32));

  ${mediaBelow(variables.breakpoints.bpMd)} {
    padding: 0 ${pxToRemMd(16)};
    margin: 0 -${pxToRemMd(16)};
    width: calc(100% + pxToRemMd(32));
  }
`;

const RowItemLabel = styled(Paragraph)`
  font-size: ${pxToRem(16)};
  font-weight: 400;
  min-width: ${pxToRem(100)};
  color: ${themeColors.colorTextSecondary};

  ${mediaBelow(variables.breakpoints.bpSm)} {
    font-size: ${pxToRemMd(12)};
  }
`;

const RowItemValue = styled(Paragraph)`
  font-size: ${pxToRem(16)};
  font-weight: 500;
  color: ${themeColors.colorTextPrimary};
  margin-right: ${pxToRem(16)};
  display: flex;
  align-items: center;
  svg {
    margin-right: ${pxToRem(8)};
    width: ${pxToRem(22)};
  }

  ${mediaBelow(variables.breakpoints.bpSm)} {
    font-size: ${pxToRemMd(12)};
    svg {
      margin-right: ${pxToRemMd(4)};
      width: ${pxToRemMd(18)};
    }
  }
`;

const RowItemButton = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  margin-left: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  svg {
    width: ${pxToRem(14)};
    color: ${themeColors.colorTextSecondary};
    margin-left: ${pxToRem(4)};
  }

  ${mediaBelow(variables.breakpoints.bpSm)} {
    font-size: ${pxToRemMd(12)};
    svg {
      margin-right: ${pxToRemMd(4)};
      width: ${pxToRemMd(14)};
    }
  }
`;

const RowItemElement = ({ label, value, onClick }) => {
  const { t } = useTranslation();
  return (
    <RowItem>
      <RowItemLabel>{label}</RowItemLabel>
      <RowItemValue>{value}</RowItemValue>
      <RowItemButton onClick={onClick}>
        {t('buyWizard.changeLabel')}
        <ArrowRight />
      </RowItemButton>
    </RowItem>
  );
};

RowItemElement.propTypes = {
  label: PropTypes.string,
  value: PropTypes.shape({}),
  onClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default RowItemElement;
